// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hvaeSFFuowg0IN {
  height: 64px;
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-top-right-radius: var(--ds-border-radius-200, 8px);
}
.LqgHiubcZnMWmo {
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-top-right-radius: var(--ds-border-radius-200, 8px);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
}
.SeedfcoRBYPLZ4 {
  height: 36px;
  overflow: hidden;
  border-top-left-radius: var(--ds-border-radius-200, 8px);
  border-top-right-radius: var(--ds-border-radius-200, 8px);
}
.SeedfcoRBYPLZ4.FiKXt7_AL_PZD8 {
  position: relative;
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.FiKXt7_AL_PZD8::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4._xPUUMneaiTWG4 {
  position: relative;
  background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4._xPUUMneaiTWG4::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.lEc9SQC9rSroyr {
  position: relative;
  background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.lEc9SQC9rSroyr::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.Q9iifm7PTQNkSx {
  position: relative;
  background-color: var(--ds-background-accent-red-subtle, #f87462);
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.Q9iifm7PTQNkSx::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.catqlYl5IqqU3t {
  position: relative;
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.catqlYl5IqqU3t::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.szFQGPi3TKo_9l {
  position: relative;
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.szFQGPi3TKo_9l::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.HdjY6P084CYvVE {
  position: relative;
  background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.HdjY6P084CYvVE::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.VvRgCNLy9EtObO {
  position: relative;
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.VvRgCNLy9EtObO::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.fhXW8H6_zB1UnM {
  position: relative;
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--ds-text-accent-magenta-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.fhXW8H6_zB1UnM::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.O6g3S_mSxta7aJ {
  position: relative;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.body-color-blind-mode-enabled .SeedfcoRBYPLZ4.O6g3S_mSxta7aJ::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.SeedfcoRBYPLZ4.fsBTEwIg4SXBRZ {
  height: 64px;
}
`, ""]);
// Exports
export var emptyCover = `hvaeSFFuowg0IN`;
export var cardFrontImageCover = `LqgHiubcZnMWmo`;
export var cardFrontCover = `SeedfcoRBYPLZ4`;
export var green = `FiKXt7_AL_PZD8`;
export var yellow = `_xPUUMneaiTWG4`;
export var orange = `lEc9SQC9rSroyr`;
export var red = `Q9iifm7PTQNkSx`;
export var purple = `catqlYl5IqqU3t`;
export var blue = `szFQGPi3TKo_9l`;
export var sky = `HdjY6P084CYvVE`;
export var lime = `VvRgCNLy9EtObO`;
export var pink = `fhXW8H6_zB1UnM`;
export var black = `O6g3S_mSxta7aJ`;
export var hasStickers = `fsBTEwIg4SXBRZ`;
export default ___CSS_LOADER_EXPORT___;
